import styles from "./firstAndLastName.module.scss";
import {Input} from "antd";
import {useEffect, useState} from "react";
import {UnregisteredUserDataDto} from "../../../api";
import {nameof} from "digimuth-components/dist";

interface FirstAndLastNameProps {
    onChange?: (person: UnregisteredUserDataDto | null) => void,
    initialValues?: UnregisteredUserDataDto;
}

export default function FirstAndLastName(props: FirstAndLastNameProps) {
    const [data, setData] = useState<UnregisteredUserDataDto | null>(null);

    const onChange = (value: string, name: string) => {
        const userData = {...data!, [name]: value};
        setData(userData);
        props.onChange?.(value.length > 0 ? userData : null);
    }

    useEffect(() => {
        if (props.initialValues) setData(props.initialValues);
    }, [props.initialValues]);

    return <div className={styles.container}>
        <Input
            placeholder={"Imię"}
            value={data?.firstName ?? ""}
            onChange={e => onChange(e.target.value, nameof<UnregisteredUserDataDto>("firstName"))}
        />
        <Input
            placeholder={"Nazwisko"}
            value={data?.lastName ?? ""}
            onChange={e => onChange(e.target.value, nameof<UnregisteredUserDataDto>("lastName"))}
        />
    </div>
}